import { useEffect, useState } from "react";
import { Grid2 } from "@mui/material";
import BillingSection from "../Components/BillingSections/BillingSection";
import BillingHeadersContent from "../Components/BillingInfo/BillingHeadersContent";
import { ReactComponent as Clonesite } from "../../../../../GlobalAssets/svg/clonesite12.svg";
import PaymentsStyle from "./PaymentsStyle.module.scss";
import PlanUsage from "../Sections/PlanUsage/PlanUsage";
import BillingHistory from "../Sections/BillingHistory/BillingHistory";
import { useMakeApiCalls } from "../../../../../Hooks/useMakeApiCalls";
import { useSelector } from "react-redux";
import { Actions } from "../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../Utils/storeUtils";
import { EmptyStateForPayments } from "../../../../../Utils/roconConstants";
import NewEmptyState from "../../../../../GlobalComponents/EmptyState/NewEmptyState";
import { useNavigate, useParams } from "react-router-dom";
import PageLoading from "../../../../../GlobalComponents/PageLoading/PageLoading";
import BillingInfo from "../Sections/BillingInfo/BillingInfo";

const Payments = () => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const selectedOrg = useSelector(
    (state) => state.organizationsInfo?.selectedOrg
  );

  const userDetails = useSelector((state) => state.users?.userDetails);

  const [selectedCountry, setSelectedCountry] = useState(
    selectedOrg?.country === "USA" || userDetails?.country === "USA"
      ? "USA"
      : "India"
  );

  const [selectedState, setSelectedState] = useState("");
  const params = useParams();
  let orgId = params.orgId;

  const [isInput, setIsInput] = useState({
    address: "",
    addresserror: false,
    city: "",
    cityerror: false,
  });

  useMakeApiCalls(() => {
    getStore().dispatch({ type: Actions.API_ORG_DASHBOARD });
    getStore().dispatch({ type: Actions.API_USER_DETAILS });
    getStore().dispatch({
      type: Actions.API_SELECTED_ORG,
      orgId: orgId,
    });
  });

  const country = selectedOrg?.country || userDetails?.country;

  const formatDateInv = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const invoiceHistory = useSelector(
    (state) => state.paymentInfo?.invoiceHistory
  );

  const stripeInfo = useSelector((state) => state.paymentInfo?.stripeInvoice);

  const upcomingInvoice = useSelector(
    (state) => state.paymentInfo?.upcomingInvoice
  );

  const plan = useSelector(
    (state) => state.plansInfo?.specificPlan?.specificPlans[0]
  );
  const specificPlan = useSelector(
    (state) => state.plansInfo?.specificPlan?.specificPlans
  );

  const dedicatedHosting = useSelector(
    (state) => state.plansInfo?.specificPlan?.isDedicated
  );

  const basePlan = specificPlan?.find((plan) => plan.basePlan === true);

  const isPlanExpiredOrExpiring =
    plan?.daysAfterExpiry <= 0 && plan?.daysAfterExpiry !== null;

  useEffect(() => {
    getStore().dispatch({
      type: Actions.GET_INVOICE_HISTORY,
      orgId: orgId,
    });

    getStore().dispatch({
      type: Actions.GET_STRIPE_INVOICE,
      orgId: orgId,
    });

    getStore().dispatch({
      type: Actions.API_GET_SEPCIFIC_PLAN,
      data: { orgId: orgId },
    });

    getStore().dispatch({
      type: Actions.GET_UPCOMING_INVOICE,
      orgId: orgId ? orgId : -1,
      country: country === "USA" ? "US" : "IN",
    });

    if (country === "USA") {
      getStore().dispatch({
        type: Actions.GET_USER_CARDS,
        data: { orgId: orgId },
        meta: {
          onSuccess: () => {},
          onError: () => {},
        },
      });
    }
  }, [selectedOrg]);

  const billingData =
    country === "India"
      ? invoiceHistory?.map((invoice) => ({
          invoiceId: invoice?.invoiceId || "",
          description: "-",
          invoiceDate: invoice?.invoiceDate?.split(" ")[0] || "",
          planCashFreeInvoiceList: invoice?.planCashFreeInvoiceList || [],
          amount: invoice?.total ? `${invoice?.total}` : "",
          status: invoice?.status?.toLowerCase() || "",
          billingType: invoice?.billingType,
          userEmail: invoice?.userEmail,
          userName: invoice?.userName,
          couponPrice: invoice?.couponPrice,
          gstPrice: invoice?.gstPrice,
        }))
      : stripeInfo?.map((info) => ({
          invoiceId: info?.invoiceId || "",
          description: "-",
          billingDate: info?.periodStart ? formatDateInv(info.periodStart) : "",
          status: info?.status || "",
          amount: info?.amountPaid
            ? `$${(info.amountPaid / 100).toFixed(2)}`
            : "",
          hostedInvoiceUrl: info?.hostedInvoiceUrl || "",
        }));

  return (
    <>
      {plan && upcomingInvoice ? (
        <>
          {plan ? (
            <Grid2
              container
              direction={"column"}
              className={PaymentsStyle.BillingInformation}
            >
              <Grid2 className={PaymentsStyle.heading}>
                Billing Information
              </Grid2>

              <Grid2>
                <BillingHeadersContent
                  currentPlan={plan}
                  invoiceBill={upcomingInvoice?.estimatedBill}
                  navigate={navigate}
                  orgId={orgId}
                  isPlanExpiredOrExpiring={isPlanExpiredOrExpiring}
                  dedicatedHosting={dedicatedHosting}
                  basePlan={basePlan}
                />
                <Grid2 className={PaymentsStyle.line} />
              </Grid2>

              {!isPlanExpiredOrExpiring && (
                <Grid2 item>
                  <BillingSection
                    header="Plan Usage"
                    content={
                      <PlanUsage
                        upcomingInvoice={upcomingInvoice}
                        specificPlan={specificPlan}
                        dedicatedHosting={dedicatedHosting}
                      />
                    }
                  />
                </Grid2>
              )}

              {/* {selectedOrg?.country == "USA" && (
                <Grid2 item>
                  <BillingSection
                    header="Payment Method"
                    sideButton=""
                    content={<PaymentCardList cardDetails={cardDetails} />}
                  />
                </Grid2>
              )} */}

              <Grid2 item>
                <BillingSection
                  header="Billing Address"
                  sideButton=""
                  content={
                    <BillingInfo
                      isInput={isInput}
                      setIsInput={setIsInput}
                      selectedOrg={selectedOrg}
                      userDetails={userDetails}
                      isChecked={isChecked}
                      setIsChecked={setIsChecked}
                      selectedCountry={selectedCountry}
                      setSelectedCountry={setSelectedCountry}
                      selectedState={selectedState}
                      setSelectedState={setSelectedState}
                      ind={orgId}
                    />
                  }
                />
              </Grid2>

              <Grid2 item>
                <BillingSection
                  header="Billing History"
                  sideButton=""
                  content={<BillingHistory data={billingData} />}
                />
              </Grid2>
            </Grid2>
          ) : (
            <NewEmptyState
              header={EmptyStateForPayments.header}
              subHeader={EmptyStateForPayments.subHeader}
              icon={Clonesite}
              title={
                <span>
                  Unlock Full Access with
                  <span style={{ color: "#135FC2" }}> LaunchPad </span>
                </span>
              }
              subTitle={EmptyStateForPayments.subTitle}
            />
          )}
        </>
      ) : (
        <PageLoading />
      )}
    </>
  );
};

export default Payments;
